<app-common-payments-dialog
  class="setup-bank-transfer-dialog"
  [dialogType]="dialogType"
  [confirmLabel]="confirmLabel"
  [confirmUrl]="confirmUrl"
  [confirmInNewWindow]="true"
  [description]="description"
  [headerLabel]="headerLabel"
  [secondaryButtonText]="learnMoreLabel"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="linkBankAccountTapped"
  [secondaryActionTapped]="viewInformationTapped"
  (onConfirm)="onConfirm.emit()"
  (onSecondaryAction)="onViewMoreClick()"
  (onCancel)="onCancel.emit()"
>
</app-common-payments-dialog>
